import type React from "react"
import styled from "styled-components"
import backgroundImage from "~/assets/arbeidsark-bg-illustration.svg"
import { OutlineButton } from "~/components"
import Toast from "~/modules/toasts/Toast"
import { useTranslate } from "~/ur-react-hooks"
import { useLogout } from "~/utils/hooks/useLogout"

const Layout = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;

  background-image: url(${backgroundImage});

  ${(props) =>
    props.theme.media.mobile &&
    `
      width: 100%;
  `}
`

const Title = styled.h3`
  font-family: 'Work Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 145%;
`

const Card = styled.div`
  display: flex;
  flex-direction: column;
  width: 456px;
  box-sizing: border-box;

  background: white;
  border-radius: 8px;
  padding: 24px;
  box-shadow: 0px 8px 32px 0px rgba(27, 12, 55, 0.12);
`

const Description = styled.p`
  line-height: 150%;
  text-align: center;
`

const Actions = styled.div`
  margin-top: 1rem;
`

export type NewSchooAwaitingConfirmationProps = {}

const NewSchooAwaitingConfirmation: React.FC<
  NewSchooAwaitingConfirmationProps
> = () => {
  const logout = useLogout()
  const translations = useTranslate({
    title: "new-school-awaiting-confirmation.title",
    description: "new-school-awaiting-confirmation.description",
    toast: "new-school-awaiting-confirmation.toast",
    logout: "common.log-out",
  })

  return (
    <Layout>
      <Card>
        <Title>{translations.title}</Title>
        <Toast type="success" message={translations.toast} />
        <Description>{translations.description}</Description>
        <Actions>
          <OutlineButton
            width="100%"
            onClick={() => {
              logout()
            }}
          >
            {translations.logout}
          </OutlineButton>
        </Actions>
      </Card>
    </Layout>
  )
}

export default NewSchooAwaitingConfirmation
